import React, { useEffect, useState, useRef } from "react";
import arrowleft from "../assets/images/arrow-left.png";
import attachfile from "../assets/images/attach_file.png";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import dropdown from "../assets/images/dropdown.png";

import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showToast } from "./ShowToast";
import DatePicker from "react-datepicker";
import { Modal } from "react-bootstrap";
import Loader from "./Loader";

export default function EditTeamInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state;
  const [toggle, setToggle] = useState(true);
  const [filename, setFilename] = useState("");
  const [files, setFile] = useState({});

  const token = GetStorage.get("xAuthToken");
  const [url, setUrl] = useState("");
  const [state, setState] = useState({
    name: "",
    coach: "",
    cell_number: "",
    pool_address: "",
    mailing_address: "",
    bank_name: "",
    account_number: "",
    routing_number: "",
    price: "",
    payment_type: "",
    csv: "Undifined",
    isSendNotification: true,
    video_send_mode_via_email_sms: "",
    lease_start_date: ""
  });
  const [showPreviewSheetModal, setShowPreviewSheetModal] = useState(false);
  const [formattedData, setformattedData] = useState([]);
  const [csvColumnsData, setCsvColumnsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);


  const csvColumns = [
    "TEAM",
    "GROUP",
    "FirstName",
    "LastName",
    "ParentEmail",
    "ParentPhone",
    "AGE",
    "GENDER",
    "ParentFirstName",
    "ParentLastName",
  ];

  const handleChangevalue = (evt) => {
    if (evt.target != undefined) {

      const { name, value } = evt.target;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      setState({
        ...state,
        lease_start_date: evt,
      });
    }
    // console.log("name===>", name);
  };

  useEffect(() => {
    EditTeamInfo();
  }, []);

  const initialValues = {
    name: "",
    coach_name: "",
    coach_email: "",
    cell_number: "",
    pool_address: "",
    mailing_address: "",
    bank_name: "",
    account_number: "",
    routing_number: "",
    price: "",
    csv: "Undifined",
    isSendNotification: true,
  };
  const validationSchema = Yup.object({
    // name: Yup.string().required("Required"),
    // coach_name: Yup.string().required("Required"),
    // coach_email: Yup.string().required("Required"),
    // cell_number: Yup.string().required("Required"),
    // pool_address: Yup.string().required("Required"),
    // mailing_address: Yup.string().required("Required"),
    // bank_name: Yup.string().required("Required"),
    // account_number: Yup.string().required("Required"),
    // routing_number: Yup.string().required("Required"),
    // price: Yup.string().required("Required"),
  });

  const onSubmit = async (values) => {
    setLoading(true)
    console.log(state);
    let formData = new FormData();
    formData.append("csv", files);
    for (let key in state) {
        if (key !== "video_send_mode_via_email_sms") {
            formData.append(key, state[key]);
        }
    }
    formData.append("video_send_mode_via_email_sms", String(state.video_send_mode_via_email_sms));

    state.csv = url;
    http
      .put(`api/admin/team?token=${token}`, formData)
      .then((res) => {
        // console.log("added new user", res.data);
        setLoading(false)
        showToast("success", res.data.message);
        setTimeout(() => {
          navigate(`/teamshark/${location.state.id}`, {
            state: {
              previousPath: location.pathname
            }
          });
        }, 3000)
      })
      .catch((error) => {
        //console.log("error ", error);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key], 8000);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message, 8000);
          }
        }
        setLoading(false)
      });
  };

  const handleSheetPreviewData = (file) => {
    setLoading(true)
    let formData = new FormData();
    formData.append("csv", file);
    formData.append("id", id);
    http
      .post(`api/admin/team/update-team/preview-sheet-data?token=${token}`, formData)
      .then((res) => {
        console.log("preview api response is called", res.data);
        setShowPreviewSheetModal(true)
        formatDataForTable(res.data.data)
        setCsvColumnsData(res.data.csvCoulmns)
        setLoading(false);

      })
      .catch((error) => {
        //console.log("error ", error);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key], 8000);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message, 8000);
          }
        }
        setLoading(false)
      });
  }

  const handleUpload = (e) => {
    const file = e.target.files[0];
    setFile(file);
    e.target.value = null;
    setFilename(file.name);

    handleSheetPreviewData(file)
  };

  // const handleUpload = (e) => {
  //   console.log(e.target.files[0]);
  //   const file = e.target.files[0];
  //   if (file.type !== "text/csv") {
  //     setError("Invalid file.");
  //     return;
  //   } else {
  //     setError("");
  //   }
  //   http
  //     .post(`api/admin/team/csv?token=${token}`, {
  //       file_type: "text/csv",
  //     })
  //     .then((res) => {
  //       console.log("response", res.data);
  //       const { url, key } = res.data;
  //       console.log(url, key);
  //       setUrl(key);
  //       fetch(url, {
  //         body: file,
  //         method: "PUT",
  //         headers: {
  //           "content-type": file.type,
  //           Accept: "*/*",
  //         },
  //       });
  //     })
  //     .catch((error) => {
  //       console.log("error ", error.response.data.errors);
  //     });
  // };

  const EditTeamInfo = () => {
    http
      .get(`api/admin/team/${id}?token=${token}`)
      .then((res) => {
        console.log("edit team info", res.data);
        res.data.isSendNotification = true;
        setState(res.data);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };

  const formatDataForTable = (data) => {
    let finalData = data.map((row) => {
      return csvColumns.map((col, index) => {
        let style = {};
        let errorMessage = "";

        // Check if the cell has been modified
        if (row.updated && row.modifiedColumns.includes(col)) {
          style = { ...style, backgroundColor: "yellow" }; // Highlight updated cells in yellow
        }

        // Check if the row has not changed
        if (row.noChange) {
          style = { ...style, backgroundColor: "green",color:"white" }; // Highlight unchanged cells in green
        }

        // Check if there are errors for the field and apply red styling
        if (row.errors[col]) {
          style = {
            ...style,
            // border: "1px solid red", // Apply red border
            backgroundColor: "red", // Text in red color
            color:"white"
          };
          errorMessage = row.errors[col]; // Set the error message for hover (tooltip)
        }

        //change white cell with color green 
        if (!style.backgroundColor) {
          style = { ...style, backgroundColor: 'green', color: 'white' };
        }


        // Return the final object with value, style, and error message
        return { value: row[col], style, errorMessage };
      });
    });

    setformattedData(finalData);
  };


  return (
    <>
      <body>
        <div className="wrapper">
          {loading && <Loader />}
          <Nav
          // sidebarClass={toggle ? "show" : "hide"}
          />

          <div id="content" className="teamInfo">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(`/teamshark/${location.state.id}`, {
                      state: {
                        previousPath: location.pathname
                      }
                    })}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Edit Team Info</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>
            <Formik
              initialValues={state}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add">
                      <h5 className="my-3">General Info</h5>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="name"
                                onChange={handleChangevalue}
                                value={state.name}
                                className="custom_input form-control"
                                placeholder="Team Name"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                disabled
                                name="coach_name"
                                value={state.coach}
                                className="custom_input form-control"
                              // placeholder="coach name"
                              />
                              <ErrorMessage name="coach_name" />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                disabled
                                type="email"
                                name="coach_email"
                                value={state.email}
                                className="custom_input form-control"
                              // placeholder="Coach Email ID"
                              />
                              <ErrorMessage name="coach_email" />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="cell_number"
                                onChange={handleChangevalue}
                                value={state.cell_number}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="pool_address"
                                onChange={handleChangevalue}
                                value={state.pool_address}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="mailing_address"
                                onChange={handleChangevalue}
                                value={state.mailing_address}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Send Email As</label>
                              <div className="custom_radio_group">
                                <label className="radio_container">
                                  Auto
                                  <input
                                    type="radio"
                                    name="video_send_mode_via_email_sms"
                                    value="auto"
                                    checked={state.video_send_mode_via_email_sms === "auto"}
                                    onChange={() => setState({ ...state, video_send_mode_via_email_sms: "auto" })}
                                  />
                                  <span className="radio_checkmark"></span>
                                </label>
                                <label className="radio_container">
                                  Manual
                                  <input
                                    type="radio"
                                    name="video_send_mode_via_email_sms"
                                    value="manual"
                                    checked={state.video_send_mode_via_email_sms === "manual"}
                                    onChange={() => setState({ ...state, video_send_mode_via_email_sms: "manual" })}
                                  />
                                  <span className="radio_checkmark"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-12">
                            <div className="upload_btn_wrapper_attach">
                              <button className="btn">
                                <img src={attachfile} className="mr-2" />
                                Attach CSV File
                              </button>
                              <input
                                type="file"
                                name="myfile"
                                onChange={handleUpload}
                              />{" "}
                            </div>
                          </div> */}
                          <div className="col-12">
                            <h5 className="my-3">Bank Details</h5>{" "}
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="bank_name"
                                onChange={handleChangevalue}
                                value={state.bank_name}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="account_number"
                                onChange={handleChangevalue}
                                value={state.account_number}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="routing_number"
                                onChange={handleChangevalue}
                                value={state.routing_number}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <h5 className="my-3">Payment method</h5>{" "}
                          </div>

                          <div className="col-md-4 col-sm-6 Edit_Setting">
                            <div
                              className="form-group icon "
                              style={{ maxWidth: "100%" }}
                            >
                              <select
                                name="payment_type"
                                value={state.payment_type}
                                onChange={handleChangevalue}
                                className="form-control custom_input w-100"
                              >
                                <option
                                  value="0"
                                // selected={
                                //   state.payment_type === 0 ? true : false
                                // }
                                >
                                  Single Pay
                                </option>
                                <option
                                  value="1"
                                // selected={
                                //   state.payment_type === 1 ? true : false
                                // }
                                >
                                  Monthly subscription
                                </option>
                              </select>
                              <div className="img_icon">
                                {" "}
                                <img src={dropdown} alt="" />{" "}
                              </div>
                            </div>
                          </div>



                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <input
                                name="price"
                                onChange={handleChangevalue}
                                value={state.price}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="form-group lease_date">
                              <DatePicker
                                selected={state.lease_start_date}
                                onChange={handleChangevalue}
                                className="custom_input form-control"
                                minDate={new Date()}
                                placeholderText="Select lease start date"
                              />
                            </div>
                          </div>
                          <div className="col-md-12 col-sm-6">
                            <div className="fomr-group">
                              <label class="check_box">
                                <input
                                  type="checkbox"
                                  name="isSendNotification"
                                  checked={values.isSendNotification}
                                  onChange={(e) => {
                                    setFieldValue("isSendNotification", e.target.checked)
                                    setState({
                                      ...state,
                                      [e.target.name]: e.target.checked,
                                    });
                                  }
                                  }
                                />
                                <span class="checkmark"></span>Allow SMS/Email
                              </label>
                            </div>
                          </div>
                          <div className="col-12 ">
                            <div
                              className="upload_btn_wrapper_attach"
                            >
                              <div style={{ cursor: 'pointer' }}>
                                <button className="btn" type="button">
                                  <img src={attachfile} className="mr-2" />
                                  Upload CSV File
                                </button>
                                <input
                                  ref={fileInputRef}
                                  type="file"
                                  name="myfile"
                                  id="file"
                                  onChange={handleUpload}
                                />{" "}
                              </div>

                            </div>
                            <div className="upload_btn_wrapper_attach">
                              <button
                                type="button"
                                className="btn ml-2" // Added margin left to space it from the first button
                                onClick={() => {
                                  // Add logic for previewing the sheet here
                                  console.log("Previewing the CSV sheet...");
                                  setShowPreviewSheetModal(true);
                                }}
                              >
                                Preview File
                              </button>
                            </div>
                          </div>
                          {
                            filename &&
                            <h5
                              style={{
                                alignItems: "center",
                                display: "flex",
                                padding: 10,
                              }}
                            >
                              {" "}
                              {filename}
                            </h5>
                          }
                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              {/* <Link to="/teams"> */}
                              <button
                                type="button"
                                className=" them_btn_ouline  "
                                onClick={() => navigate(`/teamshark/${location.state.id}`, {
                                  state: {
                                    previousPath: location.pathname
                                  }
                                })}
                              >
                                Cancel
                              </button>
                              {/* </Link> */}

                              <button
                                // to="/advancedSecuritySettings"
                                onClick={handleSubmit}
                                className=" them_btn_ouline  "
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>

            <Modal
              //  show={true}
              show={showPreviewSheetModal}
              onHide={() => setShowPreviewSheetModal(false)}
              className="teamInfo-modal"
            >
              <Modal.Header>
                <Modal.Title>Preview File Data</Modal.Title>
                <button type="button" className="close"
                  onClick={() => setShowPreviewSheetModal(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: '600px', overflowY: 'auto' }}>
                {formattedData.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>No data available</div>
                ) : (
                  <div>
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                      <div
                        style={{
                          backgroundColor: 'green',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        No Changes
                      </div>
                      <div
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        Error
                      </div>
                      <div
                        style={{
                          backgroundColor: 'yellow',
                          color: 'black',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        Will Be Updated
                      </div>
                    </div>
                    <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                         <th style={{ padding: "8px",textAlign:'center' }}>ID</th>
                          {csvColumns.map((col) => (
                            <th key={col} style={{ padding: "8px" }}>
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {formattedData.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            <td style={{ padding: "8px", textAlign: "center" }}>
                              {rowIndex + 1} {/* Displaying row number as ID */}
                            </td>
                            {row.map((cell, colIndex) => (
                              <td
                                key={colIndex}
                                style={{
                                  padding: "8px",
                                  ...cell.style,
                                }}
                                title={cell.errorMessage} // Display error message on hover
                              >
                                {cell.value}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Modal.Body>
            </Modal>

          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}
